import React from "react";
import { withTranslation } from "react-i18next";

import { Modal, ModalBody } from "reactstrap";
import Text from "components/Text";
import { useAppContext } from "context/AppContext";

function AdminAccept({ isOpen, t }) {
  const { logout } = useAppContext();

  return (
    <Modal
      isOpen={isOpen}
      className={
        "modal-dialog-centered modal-width-660 vendor-delete-office-modal"
      }
      modalClassName="custom-modal"
    >
      <ModalBody className={"text-center px-md-4"}>
        <Text size="25px" marginBottom="10px" weight="500" color="#111b45">
          {t("accountUnderReview")}
        </Text>
        <Text size="16px" marginBottom="35px" weight="300" color="#535B5F">
          {t("accountUnderReviewContent")}
        </Text>
        <button
          className="button button-round button-shadow mr-md-3 w-sm-100 md-2"
          onClick={logout}
        >
          {t("logout")}
        </button>
      </ModalBody>
    </Modal>
  );
}

export default withTranslation()(AdminAccept);
